export default __webpack_public_path__ + "static/media/inprogress_icon.70bb06bd.svg";